import { render, staticRenderFns } from "./Vccritical-Packages.vue?vue&type=template&id=206bf98e"
import script from "./Vccritical-Packages.vue?vue&type=script&lang=js"
export * from "./Vccritical-Packages.vue?vue&type=script&lang=js"
import style0 from "./Vccritical-Packages.vue?vue&type=style&index=0&id=206bf98e&prod&lang=stylus&module=attr"




function injectStyles (context) {
  
  this["attr"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonTemplate: require('/var/www/malayan/web/components/global/templates/ButtonTemplate.vue').default,AlertTemplate: require('/var/www/malayan/web/components/global/templates/AlertTemplate.vue').default})
